export default "__VITE_ASSET__7d1a11ae__"